import {BaseModel, DisableModel} from 'model/base.model';

export interface TagTask extends BaseModel, DisableModel {
  id?: number;
  status?: string;
}

export const defaultTagTask: Readonly<TagTask> = {
};